import { flexWorkerService as flexWorkerServiceHQ } from 'hq/services';
import { useInfiniteQuery } from 'react-query';
import { FlexWorkersForShiftFilters } from 'shared/components/flex-workers-for-work-table/flex-workers-for-work.types';
import { QUERY_KEYS } from 'api/query-keys';

const useGetFlexWorkersForShiftPlanning = (
  shiftId: string,
  pageSize: number,
  filters?: FlexWorkersForShiftFilters
) => {
  const queryKey = QUERY_KEYS.workersForShift(shiftId, filters);
  const queryFn = async ({ pageParam = 0 }) =>
    await flexWorkerServiceHQ.getAllFlexWorkers({ shiftId, page: pageParam, pageSize, filters });

  return useInfiniteQuery({
    queryKey: queryKey,
    queryFn: queryFn,
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });
};

export { useGetFlexWorkersForShiftPlanning };
